/* eslint-disable no-unused-vars */
import { App, Button } from "antd";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { eeIncentiveTableDomestic } from "@/utils/tariffConstants";
import ElectricityTariffTable from "./ElectricityTariffTable";

export default function ElectricityTariff() {
  const { notification } = App.useApp();
  const [isLoading, setIsLoading] = useState(false);
  const [eTariff, setETariff] = useState([]);
  const [eeIncentiveTable, setEeIncentiveTable] = useState(eeIncentiveTableDomestic);
  const [mode, setMode] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onUpdateTariff = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        api.put(endpoint.get_electricity_tariff, { data: eTariff }),
        api.put(endpoint.electricity_tariff_settings, { eeIncentiveTable }),
      ]);
      await Promise.all([getElectricityTariff(), getTariffSettings()]);

      notification.success({
        key: "electricity-tariff-update",
        message: "Electricity Tariff Updated Successfully",
        duration: 2,
        showProgress: true,
      });
      setMode(false);
    } catch (error) {
      notification.error({
        key: "electricity-tariff-update",
        message: error?.response?.data?.message || "Failed to update electricity tariff",
        duration: 2,
        showProgress: true,
      });
    } finally {
      setIsLoading(false);
    }
  };
  const getElectricityTariff = async () => {
    setIsLoading(true);
    try {
      let { results, count } = await api.get(endpoint.get_electricity_tariff, {
        params: { limit, page, sortBy: "position", orderBy: "ASC" },
      });

      const filtered = (results || []).filter(
        (item) => !item.name.toLowerCase().startsWith("tariff ")
      );
      const unique = Array.from(new Map(filtered.map((item) => [item.name, item])).values());
      const mapped = unique.map((item, idx) => {
        item.sl = (page - 1) * limit + idx + 1;
        return item;
      });
      setETariff(mapped);
      setTotal(count || 0);
    } finally {
      setIsLoading(false);
    }
  };
  const getTariffSettings = async () => {
    try {
      const { result } = await api.get(endpoint.electricity_tariff_settings);
      if (result?.eeIncentiveTable?.length) setEeIncentiveTable(result.eeIncentiveTable);
    } catch (error) {
      // Keep the default rebate table if settings are unavailable
    }
  };
  useEffect(() => {
    getElectricityTariff();
  }, [limit, page]);

  useEffect(() => {
    getTariffSettings();
  }, []);

  useEffect(() => {
    document.title = `${appConfig.name} - Manage Electricity Tariff`;
  }, []);
  return (
    <div className="card p-3 m-md-3">
      {/* <h3>Electricity Tariff</h3> */}
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <label className="az-content-label">Settings</label>
          <span className="d-block py-2">Manage Electricity Tariff</span>
        </div>
      </div>
      <hr className="mt-0" />
      <div className="row mt-4">
        <div className={`col-md-12`}>
          <ElectricityTariffTable
            listLoading={isLoading}
            getElectricityTariff={getElectricityTariff}
            eTariff={eTariff}
            setETariff={setETariff}
            eeIncentiveTable={eeIncentiveTable}
            setEeIncentiveTable={setEeIncentiveTable}
            mode={!mode}
          />
          <div className="d-flex justify-content-end mt-5">
            {mode ? (
              <>
                {" "}
                <Button type="primary" className=" me-2" loading={isLoading} onClick={onUpdateTariff}>
                  Update Tariff
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  className="bg-secondary"
                  onClick={() => {
                    getElectricityTariff();
                    getTariffSettings();
                    setMode(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                className="me-2"
                type="primary"
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to make changes to the electricity tariff?",
                    //icon: "warning",
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setMode(true);
                    }
                  });
                }}
              >
                Edit Tariff
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
